import { motion } from 'framer-motion/dist/framer-motion';

interface IOverlayFilterProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const OverlayFilter: React.FC<IOverlayFilterProps> = ({
  children,
  onClick,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25 }}
      className="fixed left-0 top-0 z-50 grid h-full w-full content-center overflow-hidden"
      onClick={onClick}
      style={{ backgroundColor: 'rgba(49, 46, 69, 0.9)' }}
    >
      {children}
    </motion.div>
  );
};

export default OverlayFilter;
